import React from "react";
import {
    Alert,
    Box,
    Checkbox,
    CircularProgress,
    FormControlLabel,
} from "@mui/material";
import { LeisureActivityIcon } from "../../../utils/leisureActivityIcons";

export default function SectionFreizeitSport({
                                                 form,
                                                 setForm,
                                                 leisureActivities,
                                                 leisureActivitiesLoading,
                                                 leisureActivitiesError,
                                             }) {
    const ids = new Set((form.leisure_activity_ids || []).map(Number));

    const sorted = React.useMemo(() => {
        return [...(leisureActivities || [])]
            .filter((item) => item.is_active !== false)
            .sort((a, b) => Number(a.sort_order || 0) - Number(b.sort_order || 0) || String(a.label_de || "").localeCompare(String(b.label_de || ""), "de"));
    }, [leisureActivities]);

    const toggle = (id) => {
        setForm((f) => {
            const current = new Set((f.leisure_activity_ids || []).map(Number));
            if (current.has(id)) current.delete(id);
            else current.add(id);
            return { ...f, leisure_activity_ids: [...current] };
        });
    };

    if (leisureActivitiesLoading) {
        return (
            <Box sx={{ py: 2, textAlign: "center" }}>
                <CircularProgress size={22} />
            </Box>
        );
    }

    if (leisureActivitiesError) return <Alert severity="error">{leisureActivitiesError}</Alert>;

    if (!sorted.length) {
        return <Alert severity="info">Keine Freizeit/Sport-Einträge vorhanden. Lege sie zuerst in der Verwaltung an.</Alert>;
    }

    return (
        <Box>
            <Box
                sx={{
                    display: "grid",
                    gridTemplateColumns: { xs: "1fr", md: "repeat(2, minmax(0, 1fr))", lg: "repeat(3, minmax(0, 1fr))" },
                    gap: 1,
                }}
            >
                {sorted.map((activity) => (
                    <FormControlLabel
                        key={activity.id}
                        control={
                            <Checkbox
                                size="small"
                                checked={ids.has(Number(activity.id))}
                                onChange={() => toggle(Number(activity.id))}
                            />
                        }
                        label={
                            <Box sx={{ display: "inline-flex", alignItems: "center", gap: 0.75 }}>
                                <LeisureActivityIcon iconName={activity.icon_name} />
                                <span>{activity.label_de || activity.name}</span>
                            </Box>
                        }
                    />
                ))}
            </Box>
        </Box>
    );
}
